module.exports = __webpack_public_path__ + "img/rush-banner.44270658.png";